import { useEffect, useState } from "react";

import { Button } from "atoms/button/Button";
import { TextArea } from "atoms/TextArea";

import { QuizStepProps } from "../useQuestionnaire";

import YesNo from "./components/YesNo";

export const PreviousWLAttempts = (props: QuizStepProps) => {
  const hasError = !!props.errors?.PreviousWLAttempts;
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);

  const handleChange = (value: string) => {
    props.handleStepData("PreviousWLAttemptsQuestion", value);
    props.handleStepData("PreviousWLAttempts", "");
    if (value === "No") {
      setLastUpdate({ key: "PreviousWLAttemptsQuestion", value });
    }
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex h-full flex-col">
      <p className="pb-4 font-serif text-h3">
        Have you ever attempted to lose weight in a weight management program,
        such as through caloric restriction, exercise, or behavior modification?
        If so, please provide brief details.
      </p>
      <div className="flex gap-3">
        <YesNo
          value={props.data.PreviousWLAttemptsQuestion}
          onChange={(value) => handleChange(value)}
        />
      </div>
      <div
        hidden={props.data.PreviousWLAttemptsQuestion !== "Yes"}
        className="mt-4"
      >
        <TextArea
          label="Previous WLAttempts"
          value={props.data.PreviousWLAttempts as string}
          invalid={hasError}
          onChange={(value) =>
            props.handleStepData("PreviousWLAttempts", value)
          }
        />
      </div>
      <div
        hidden={props.data.PreviousWLAttemptsQuestion !== "Yes"}
        className="mt-auto"
      >
        <Button fullWidth onClick={() => props.next?.()}>
          Next Question
        </Button>
      </div>
    </div>
  );
};
